var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.396 43.396"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 36",
    d: "M26.774 14.635h-2.456a1.063 1.063 0 00-.977.878v2.5h3.428a47.306 47.306 0 01-.42 3.676h-3.024v10.882h-4.507V21.692h-2.194V18.03h2.194v-2.995c0-.547-.111-4.213 4.618-4.213h3.339zm16.623 7.064a21.7 21.7 0 00-21.7-21.7 21.7 21.7 0 00-21.7 21.7 21.7 21.7 0 0021.7 21.7 21.7 21.7 0 0021.7-21.7",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "8898254100de0c1be07c043c0342489d.svg";
export { SvgFacebookCircle as ReactComponent };